import {Section} from '.';
import {Typography} from '@material-ui/core';
import {AutoField} from './fields';

const checkField = value => {
    if (
        value === null ||
        value === 'null' ||
        value === undefined ||
        value === 'undefined'
    ) {
        return null;
    } else if (value === true || value === 'true') {
        return 'true';
    } else if (value === false || value === 'false') {
        return 'false';
    } else if (Array.isArray(value)) {
        return value;
    } else {
        return `${value}`;
    }
};

const getInitialValues = (existingData, sectionFields, fieldDict) => {
    const output = {};
    sectionFields?.forEach(field => {
        output[fieldDict?.[field]?.name || field] =
            checkField(existingData?.[field]) ||
            checkField(fieldDict?.[field]?.initialValue);
    });
    return output;
};

const getSchema = (sectionFields, fieldDict) => {
    const output = {};
    sectionFields?.forEach(field => {
        output[fieldDict?.[field]?.name || field] =
            fieldDict?.[field]?.validation;
    });
    return output;
};

const getSections = fields => {
    if (fields) {
        const sections = {};
        Object.keys(fields).forEach(field => {
            if (fields[field].section in sections) {
                sections[fields[field].section].push(field);
            } else {
                sections[fields[field].section] = [field];
            }
        });
        return sections;
    } else {
        return null;
    }
};

const AutoSection = ({
    sectionName,
    sectionFields,
    existingData,
    fieldDict,
    ...props
}) => {
    const schema = getSchema(sectionFields, fieldDict);
    const initialValues = getInitialValues(
        existingData,
        sectionFields,
        fieldDict
    );

    return (
        <Section {...props} schema={schema} initialValues={initialValues}>
            <Typography variant='h6' align='left'>
                {sectionName}
            </Typography>
            {sectionFields?.map(field => (
                <AutoField
                    field={fieldDict[field]}
                    name={`${field}`}
                    key={`${field}`}
                />
            ))}
            {props.children}
        </Section>
    );
};

const bootstrapOldForm = (sectionName, fieldsDict, existingData = {}) => {
    const sections = getSections(fieldsDict);
    const sectionFields = sectionName
        ? sections[sectionName]
        : Object.keys(fieldsDict);
    const schema = getSchema(sectionFields, fieldsDict);
    const initialValues = getInitialValues(
        existingData,
        sectionFields,
        fieldsDict
    );
    return {
        schema: schema,
        initialValues: initialValues,
        sectionFields: sectionFields,
    };
};

export default AutoSection;
export {checkField, getInitialValues, getSchema, getSections, bootstrapOldForm};
